import { render, staticRenderFns } from "./WriteMessagePopup.vue?vue&type=template&id=558f5897&"
import script from "./WriteMessagePopup.vue?vue&type=script&lang=js&"
export * from "./WriteMessagePopup.vue?vue&type=script&lang=js&"
import style0 from "./WriteMessagePopup.vue?vue&type=style&index=0&id=558f5897&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports